export default "__VITE_ASSET__BYZ8IlZR__"